import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Stethoscope, Building2 } from "lucide-react";
import AppFooter from "../components/AppFooter";

export default function Services() {
  const navigate = useNavigate();

  const services = [
    {
      icon: <Stethoscope className="w-6 h-6 text-cyan-600" />,
      title: "AI Powered Care Assistant",
      content: `AICA provides Sound Prescription and other assistive services to doctors for beyond standard patient care starting at Rs 99/-onwards.`,
    },
    {
      icon: <Building2 className="w-6 h-6 text-cyan-600" />,
      title: "Billing Information",
      content: `AICA HEALTH TECH Pvt Ltd
1st Floor, D-48, Ajay Enclave,
New Delhi - 110018`,
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-cyan-50 to-blue-100 relative overflow-hidden">

      {/* Background Glow */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-white/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-[350px] h-[350px] bg-cyan-300/30 rounded-full blur-3xl"></div>

      {/* Grid Overlay */}
      <div className="absolute inset-0 opacity-[0.04] bg-[linear-gradient(to_right,#0f172a_1px,transparent_1px),linear-gradient(to_bottom,#0f172a_1px,transparent_1px)] bg-[size:40px_40px]"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 py-10">

        {/* Header */}
        <div className="text-center mb-12">

          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white/70 border border-cyan-200 backdrop-blur-xl text-cyan-700 shadow-lg">
            <Stethoscope size={18} />
            AICA HEALTH SERVICES
          </div>

          <h1 className="mt-6 text-4xl sm:text-5xl font-bold text-slate-800">
            Our Services
          </h1>

          <p className="mt-4 max-w-3xl mx-auto text-slate-600 text-sm sm:text-base leading-relaxed">
            Smart AI-powered healthcare assistance designed to make healthcare
            guidance simple, accessible, and affordable.
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid gap-6">

          {services.map((item, index) => (
            <div
              key={index}
              className="relative overflow-hidden rounded-3xl border border-white/40 bg-white/60 backdrop-blur-2xl shadow-xl p-6 sm:p-8 hover:bg-white/70 transition-all duration-300 hover:scale-[1.01]"
            >
              {/* glow overlay */}
              <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent pointer-events-none"></div>

              <div className="relative z-10 flex items-start gap-4">

                <div className="bg-white p-3 rounded-2xl shadow-md">
                  {item.icon}
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-800 mb-2">
                    {item.title}
                  </h2>

                  <p className="text-slate-600 whitespace-pre-line leading-relaxed text-sm sm:text-base">
                    {item.content}
                  </p>
                </div>

              </div>
            </div>
          ))}

        </div>

        {/* Footer */}
          <div className="mt-10 flex justify-center">
        
                  <button
                    onClick={() => navigate("/")}
                    className="
                    flex items-center gap-2
                    px-6 py-3
                    rounded-2xl
                    bg-gradient-to-r from-cyan-500 to-blue-500
                    text-white
                    font-semibold
                    shadow-lg
                    hover:scale-105
                    hover:shadow-cyan-300/50
                    transition-all duration-300
                  "
                  >
                    <ArrowLeft size={18} />
                    Go Back
                  </button>
        
                </div>
        


      </div>

      {/* <AppFooter /> */}
    </div>
  );
}